import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Box, Typography, Grid, IconButton } from "@mui/material";
import PropTypes from "prop-types";

function ModalComponent({
  title,
  handleCloseModal,
  ModalBody,
  openModal,
  isLocked,
}) {
  return (
    <div className="b-modal-container">
      <Modal
        className="b-modal-container__parent"
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="b-modal-container__box">
          <Typography className={`b-modal-container__typography-${isLocked}`}>
            <Grid container>
              <Grid item xs={11.5}>
                <p className={`b-modal-container__title-${isLocked}`}>
                  {title}
                </p>
              </Grid>
              <Grid item xs={0.5}>
                {/* <IconButton>
                  <CloseIcon
                    className="b-modal-container__closeIcon"
                    onClick={handleCloseModal}
                  />
                </IconButton> */}
                <IconButton onClick={handleCloseModal}>
                  <CloseIcon className="b-modal-container__closeIcon" />
                </IconButton>
              </Grid>
            </Grid>
          </Typography>
          <Box className="b-modal-container__body">{ModalBody}</Box>
        </Box>
      </Modal>
    </div>
  );
}

ModalComponent.propTypes = {
  // isLocked: PropTypes.bool.isRequired,
  // title: PropTypes.string.isRequired,
  // openModal: PropTypes.string.isRequired,
  // handleCloseModal: PropTypes.func.isRequired,
  // ModalBody: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isLocked: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  openModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  ModalBody: PropTypes.node,
};
ModalComponent.defaultProps = {
  ModalBody: null,
};

export default ModalComponent;
